/** Friert Katalog- und Rollen-Daten samt aller verschachtelten Objekte und Listen ein (nur intern, nicht exportiert). */
export function deepFreeze<T>(value: T): T {
  if (value !== null && typeof value === 'object' && !Object.isFrozen(value)) {
    Object.freeze(value);
    for (const inner of Object.values(value)) deepFreeze(inner);
  }
  return value;
}
